import { render, staticRenderFns } from "./WeightSubmissionModal.vue?vue&type=template&id=8422822c&scoped=true"
import script from "./WeightSubmissionModal.vue?vue&type=script&lang=js"
export * from "./WeightSubmissionModal.vue?vue&type=script&lang=js"
import style0 from "./WeightSubmissionModal.vue?vue&type=style&index=0&id=8422822c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8422822c",
  null
  
)

export default component.exports